import BaseComponent from '/webresources-sources/js/components/base-component';
import { defineComponent } from "/webresources-sources/js/util/jquery";

export default class HTMLComponent extends BaseComponent {
	javaScriptExecuted = false;

	connected() {
		this.id = this.element.id;
		this.executeJavaScript();
	}

	events() {
		return {
			this: {
				'html-component-script-added': (e) => {
					e.stopPropagation();
					if (!this.javaScriptExecuted) {
						this.executeJavaScript();
					}
				}
			}
		}
	}

	executeJavaScript() {
		if (this.id && window.htmlComponentScripts && window.htmlComponentScripts[this.id] && typeof window.htmlComponentScripts[this.id] === "function") {
			window.htmlComponentScripts[this.id]();
			this.javaScriptExecuted = true;
		}
	}
}

defineComponent('html-component', HTMLComponent);
